import bootstrap from "./bootstrap";

bootstrap(() =>
  import(
    /* webpackPreload: true, webpackChunkName: "ci" */ "../components/containers/customerItems/EntryPoint"
  )
);
